// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enLanding from './locales/en/landing.json';
import enCommon from './locales/en/common.json';
import enPartner from './locales/en/partner.json';
import enGuides from './locales/en/guides.json';
import enGeneral from './locales/en/general.json';
import enSubscription from './locales/en/subscription.json';
import enAdmin from './locales/en/admin.json';
import enUserprofile from './locales/en/userprofile.json';
import enUser from './locales/en/user.json';
import enPartnerOnboarding from './locales/en/partnerOnboarding.json';

// Import German translations
import deLanding from './locales/de/landing.json';
import deCommon from './locales/de/common.json';
import dePartner from './locales/de/partner.json';
import deGuides from './locales/de/guides.json';
import deGeneral from './locales/de/general.json';
import deSubscription from './locales/de/subscription.json';
import deAdmin from './locales/de/admin.json';
import deUserprofile from './locales/de/userprofile.json';
import deUser from './locales/de/user.json';
import dePartnerOnboarding from './locales/de/partnerOnboarding.json';

// Import Croatian translations
import hrLanding from './locales/hr/landing.json';
import hrCommon from './locales/hr/common.json';
import hrPartner from './locales/hr/partner.json';
import hrGuides from './locales/hr/guides.json';
import hrGeneral from './locales/hr/general.json';
import hrSubscription from './locales/hr/subscription.json';
import hrAdmin from './locales/hr/admin.json';
import hrUserprofile from './locales/hr/userprofile.json';
import hrUser from './locales/hr/user.json';
import hrPartnerOnboarding from './locales/hr/partnerOnboarding.json';

// Import Spanish translations
import esLanding from './locales/es/landing.json';
import esCommon from './locales/es/common.json';
import esPartner from './locales/es/partner.json';
import esGuides from './locales/es/guides.json';
import esGeneral from './locales/es/general.json';
import esSubscription from './locales/es/subscription.json';
import esAdmin from './locales/es/admin.json';
import esUserprofile from './locales/es/userprofile.json';
import esUser from './locales/es/user.json';
import esPartnerOnboarding from './locales/es/partnerOnboarding.json';

// Import Italian translations
import itLanding from './locales/it/landing.json';
import itCommon from './locales/it/common.json';
import itPartner from './locales/it/partner.json';
import itGuides from './locales/it/guides.json';
import itGeneral from './locales/it/general.json';
import itSubscription from './locales/it/subscription.json';
import itAdmin from './locales/it/admin.json';
import itUserprofile from './locales/it/userprofile.json';
import itUser from './locales/it/user.json';
import itPartnerOnboarding from './locales/it/partnerOnboarding.json';

// Import French translations
import frLanding from './locales/fr/landing.json';
import frCommon from './locales/fr/common.json';
import frPartner from './locales/fr/partner.json';
import frGuides from './locales/fr/guides.json';
import frGeneral from './locales/fr/general.json';
import frSubscription from './locales/fr/subscription.json';
import frAdmin from './locales/fr/admin.json';
import frUserprofile from './locales/fr/userprofile.json';
import frUser from './locales/fr/user.json';
import frPartnerOnboarding from './locales/fr/partnerOnboarding.json';

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        landing: enLanding,
        common: enCommon,
        partner: enPartner,
        guides: enGuides,
        general: enGeneral,
        subscription: enSubscription,
        admin: enAdmin,
        userprofile: enUserprofile,
        user: enUser,
        partnerOnboarding: enPartnerOnboarding
      },
      de: {
        landing: deLanding,
        common: deCommon,
        partner: dePartner,
        guides: deGuides,
        general: deGeneral,
        subscription: deSubscription,
        admin: deAdmin,
        userprofile: deUserprofile,
        user: deUser,
        partnerOnboarding: dePartnerOnboarding
      },
      hr: {
        landing: hrLanding,
        common: hrCommon,
        partner: hrPartner,
        guides: hrGuides,
        general: hrGeneral,
        subscription: hrSubscription,
        admin: hrAdmin,
        userprofile: hrUserprofile,
        user: hrUser,
        partnerOnboarding: hrPartnerOnboarding
      },
      es: {
        landing: esLanding,
        common: esCommon,
        partner: esPartner,
        guides: esGuides,
        general: esGeneral,
        subscription: esSubscription,
        admin: esAdmin,
        userprofile: esUserprofile,
        user: esUser,
        partnerOnboarding: esPartnerOnboarding
      },
      it: {
        landing: itLanding,
        common: itCommon,
        partner: itPartner,
        guides: itGuides,
        general: itGeneral,
        subscription: itSubscription,
        admin: itAdmin,
        userprofile: itUserprofile,
        user: itUser,
        partnerOnboarding: itPartnerOnboarding
      },
      fr: {
        landing: frLanding,
        common: frCommon,
        partner: frPartner,
        guides: frGuides,
        general: frGeneral,
        subscription: frSubscription,
        admin: frAdmin,
        userprofile: frUserprofile,
        user: frUser,
        partnerOnboarding: frPartnerOnboarding
      }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'hr', 'es', 'it', 'fr'],
    nonExplicitSupportedLngs: true, // Allow en-GB, en-US, etc. to fallback to 'en'
    load: 'languageOnly', // Load only language code, not regional variants (e.g., 'en' not 'en-GB')
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false // React already safes from XSS
    },
    ns: ['landing', 'common', 'partner', 'guides', 'general', 'subscription', 'admin', 'userprofile', 'user', 'partnerOnboarding'],
    defaultNS: 'common'
  });

export default i18n;
